<template>
	<transition name="slide-fade">
		<v-container fluid>
			<v-layout wrap>
				<v-flex xs12 class="pa-1">
					<v-card>
						<v-card-text>
							<ul class="list-group">
								<li class="list-group-item"><b>Permission</b> - {{permission.name}}</li>
								<li class="list-group-item"><b>Description</b> - {{permission.label}}</li>
							</ul>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex md6 sm6 xs12>
					<attach :permission="permission" :users="users" class="pa-1"></attach>
					<users :permission="permission" class="pa-1"></users>
				</v-flex>
				<v-flex md6 sm6 xs12 class="pa-1">
					<roles :permission="permission"></roles>
				</v-flex>
			</v-layout>
		</v-container>
	</transition>
</template>

<script>
	import layout from '@/Layouts/Admin'
	const users = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "admin" */ './users.vue')
	const roles = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "admin" */ './roles.vue')
	const attach = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "admin" */ './attach.vue')

	export default {
		name: 'Permission',
		layout,
		props: [
			'permission', 'users'
		],
		components: {
			users,
			roles,
			attach
		},
		data() {
			return {
				loading: true
			}
		},
		metaInfo () {
			return {
				title: 'Permission | ' + this.permission.name,
				titleTemplate: '%s | ' + this.$title
			}
		},
		methods: {
			//
		},
	}
</script>

<style>
	/**/
</style>
